import React from 'react';
import { zonedDayKey } from '../utils/kernelTimezone';

// Piccoli elementi grafici in stile "database" di Notion, condivisi dalle
// pagine di ticket e CRM: titolo con icona, schede di vista,
// intestazioni di colonna con icona e pillole colorate.

const ICON_PATHS = {
  pie: (
    <>
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
      <path d="M22 12A10 10 0 0 0 12 2v10z" />
    </>
  ),
  trend: (
    <>
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
      <polyline points="16 7 22 7 22 13" />
    </>
  ),
  company: (
    <>
      <path d="M3 21h18" />
      <path d="M5 21V7l7-4 7 4v14" />
      <path d="M9 9h.01M15 9h.01M9 13h.01M15 13h.01M9 17h.01M15 17h.01" />
    </>
  ),
  leads: (
    <>
      <circle cx="9" cy="7" r="4" />
      <path d="M2 21c0-3.9 3.1-7 7-7s7 3.1 7 7" />
      <line x1="19" y1="8" x2="19" y2="14" />
      <line x1="16" y1="11" x2="22" y2="11" />
    </>
  ),
  deals: (
    <>
      <rect x="3" y="4" width="4" height="16" rx="1" />
      <rect x="10" y="8" width="4" height="12" rx="1" />
      <rect x="17" y="12" width="4" height="8" rx="1" />
    </>
  ),
  activities: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <line x1="8" y1="3" x2="8" y2="7" />
      <line x1="16" y1="3" x2="16" y2="7" />
      <polyline points="8 13 11 16 16 10" />
    </>
  ),
  payments: (
    <>
      <rect x="1" y="4" width="22" height="16" rx="2" />
      <line x1="1" y1="10" x2="23" y2="10" />
    </>
  ),
  chart: (
    <>
      <line x1="4" y1="20" x2="20" y2="20" />
      <rect x="5" y="11" width="3.5" height="9" rx="1" />
      <rect x="10.25" y="5" width="3.5" height="15" rx="1" />
      <rect x="15.5" y="8" width="3.5" height="12" rx="1" />
    </>
  ),
  euro: (
    <>
      <path d="M18 6.5A7 7 0 1 0 18 17.5" />
      <line x1="4" y1="10" x2="14" y2="10" />
      <line x1="4" y1="14" x2="14" y2="14" />
    </>
  ),
  hash: (
    <>
      <line x1="4" y1="9" x2="20" y2="9" />
      <line x1="4" y1="15" x2="20" y2="15" />
      <line x1="10" y1="3" x2="8" y2="21" />
      <line x1="16" y1="3" x2="14" y2="21" />
    </>
  ),
  tag: (
    <>
      <path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.24L4 3a1 1 0 0 0-1 1l.24 5.59a2 2 0 0 0 .59 1.41l9.58 9.58a2 2 0 0 0 2.83 0l4.35-4.35a2 2 0 0 0 0-2.82z" />
      <circle cx="8.5" cy="8.5" r="1.5" />
    </>
  ),
  user: (
    <>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </>
  ),
  users: (
    <>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </>
  ),
  mail: (
    <>
      <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </>
  ),
  priority: (
    <>
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </>
  ),
  status: <circle cx="12" cy="12" r="9" strokeDasharray="3 3" />,
  link: (
    <>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </>
  ),
  key: <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </>
  ),
  table: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="3" y1="15" x2="21" y2="15" />
      <line x1="9" y1="3" x2="9" y2="21" />
    </>
  ),
  board: (
    <>
      <rect x="3" y="3" width="7" height="18" rx="1.5" />
      <rect x="14" y="3" width="7" height="11" rx="1.5" />
    </>
  ),
  star: <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />,
  ticket: (
    <>
      <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
      <line x1="9" y1="5" x2="9" y2="19" strokeDasharray="2 2" />
    </>
  ),
  folder: <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />,
  search: (
    <>
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </>
  ),
  briefcase: (
    <>
      <rect x="2" y="7" width="20" height="14" rx="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </>
  ),
  paperclip: <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />,
  back: (
    <>
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </>
  ),
  zap: <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />,
  layout: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="9" y1="21" x2="9" y2="9" />
    </>
  ),
  bell: (
    <>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </>
  ),
  edit: (
    <>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
    </>
  ),
  list: (
    <>
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </>
  ),
  phone: <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.58 2.81.7A2 2 0 0 1 22 16.92z" />,
  filter: <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />,
  sort: (
    <>
      <path d="M7 4v16" />
      <path d="M3 16l4 4 4-4" />
      <path d="M17 20V4" />
      <path d="M13 8l4-4 4 4" />
    </>
  ),
  eye: (
    <>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  eyeoff: (
    <>
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </>
  ),
  grip: (
    <>
      <circle cx="9" cy="6" r="1" />
      <circle cx="15" cy="6" r="1" />
      <circle cx="9" cy="12" r="1" />
      <circle cx="15" cy="12" r="1" />
      <circle cx="9" cy="18" r="1" />
      <circle cx="15" cy="18" r="1" />
    </>
  ),
  layers: (
    <>
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </>
  ),
  more: (
    <>
      <circle cx="5" cy="12" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="19" cy="12" r="1" />
    </>
  ),
  copy: (
    <>
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </>
  ),
  trash: (
    <>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </>
  ),
  plus: (
    <>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </>
  ),
  mic: (
    <>
      <rect x="9" y="2" width="6" height="12" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0" />
      <line x1="12" y1="18" x2="12" y2="22" />
    </>
  ),
  arrowUp: (
    <>
      <line x1="12" y1="19" x2="12" y2="5" />
      <polyline points="5 12 12 5 19 12" />
    </>
  ),
  arrowDown: (
    <>
      <line x1="12" y1="5" x2="12" y2="19" />
      <polyline points="19 12 12 19 5 12" />
    </>
  ),
  chat: (
    <>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </>
  ),
  sparkle: (
    <>
      <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z" /><path d="M19 15l.7 1.8 1.8.7-1.8.7L19 20l-.7-1.8-1.8-.7 1.8-.7L19 15z" />
    </>
  ),
  chevronRight: <polyline points="9 6 15 12 9 18" />,
  save: (
    <>
      <path d="M5 4h11l3 3v13H5z" />
      <path d="M8 4v5h7V4" />
      <rect x="8" y="13" width="8" height="7" rx="1" />
    </>
  ),
  send: (
    <>
      <path d="M21 3L10 14" />
      <path d="M21 3l-7 18-4-7-7-4z" />
    </>
  ),
  download: (
    <>
      <path d="M12 4v11" />
      <path d="M7 11l5 5 5-5" />
      <path d="M5 20h14" />
    </>
  ),
  printer: (
    <>
      <path d="M7 9V4h10v5" />
      <rect x="4" y="9" width="16" height="8" rx="2" />
      <rect x="8" y="14" width="8" height="6" rx="1" />
    </>
  ),
  sliders: (
    <>
      <line x1="3" y1="7" x2="21" y2="7" />
      <circle cx="9" cy="7" r="2.4" />
      <line x1="3" y1="17" x2="21" y2="17" />
      <circle cx="15" cy="17" r="2.4" />
    </>
  ),
  groupBy: (
    <>
      <rect x="3" y="4" width="4" height="4" rx="1" />
      <rect x="10" y="4" width="4" height="4" rx="1" />
      <rect x="17" y="4" width="4" height="4" rx="1" />
      <rect x="3" y="11" width="4" height="4" rx="1" />
      <rect x="10" y="11" width="4" height="4" rx="1" />
      <rect x="17" y="11" width="4" height="4" rx="1" />
      <line x1="3" y1="19" x2="21" y2="19" />
    </>
  ),
  insertLeft: (
    <>
      <line x1="3" y1="5" x2="3" y2="19" />
      <line x1="21" y1="12" x2="8" y2="12" />
      <polyline points="12 8 8 12 12 16" />
    </>
  ),
  insertRight: (
    <>
      <line x1="21" y1="5" x2="21" y2="19" />
      <line x1="3" y1="12" x2="16" y2="12" />
      <polyline points="12 8 16 12 12 16" />
    </>
  ),
};

export function NtIcon({ name, size = 14 }) {
  if (name === 'text') {
    return <span className="nt-icon-text" style={{ fontSize: size - 1 }} aria-hidden="true">Aa</span>;
  }
  return (
    <svg
      className="nt-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {ICON_PATHS[name]}
    </svg>
  );
}

// Palette delle pillole, come in Notion (grigio, blu, verde, giallo, ...).
export const NT_COLORS = {
  grey: '#8a8f98',
  blue: '#2383e2',
  green: '#2f9e6a',
  yellow: '#d9a21b',
  orange: '#d9730d',
  red: '#d9534f',
  purple: '#a15cc2',
};

export const STATUS_COLORS = {
  open: NT_COLORS.grey,
  in_progress: NT_COLORS.blue,
  waiting_customer: NT_COLORS.yellow,
  resolved: NT_COLORS.green,
  closed: NT_COLORS.purple,
};

export const PRIORITY_COLORS = {
  low: NT_COLORS.green,
  medium: NT_COLORS.yellow,
  high: NT_COLORS.orange,
  urgent: NT_COLORS.red,
};

/** Pillola colorata: `dot` = forma tonda con pallino (stato), altrimenti etichetta (priorità, progetto, tag). */
export function Pill({ color = NT_COLORS.grey, dot = false, title, children }) {
  return (
    <span className={`nt-pill${dot ? ' nt-pill-dot' : ''}`} style={{ '--pill': color }} title={title}>
      {children}
    </span>
  );
}

/** Titolo grande della pagina con icona e sottotitolo. */
export function PageHeading({ icon, title, subtitle }) {
  return (
    <div className="nt-heading">
      <span className="nt-heading-icon"><NtIcon name={icon} size={36} /></span>
      <div>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </div>
  );
}

/** Schede di vista (come "Per stato / Tutti i progetti / Gantt") con, a destra, le azioni passate come children. */
export function ViewTabs({ tabs, active, onChange, children }) {
  return (
    <div className="nt-tabs">
      <div className="nt-tabs-list" role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active === tab.key}
            className={`nt-tab${active === tab.key ? ' nt-tab-active' : ''}`}
            onClick={() => onChange && onChange(tab.key)}
          >
            <NtIcon name={tab.icon} size={15} />
            {tab.label}
          </button>
        ))}
      </div>
      <div className="nt-tabs-actions">{children}</div>
    </div>
  );
}

/** Intestazione di colonna con l'icona della proprietà. */
export function Th({ icon, children }) {
  return (
    <th>
      <span className="nt-th">
        {icon && <NtIcon name={icon} />}
        {children}
      </span>
    </th>
  );
}

/** Riquadro con un numero in evidenza (totali, conteggi). `tone`: green | orange | red. */
export function StatCard({ icon, tone, value, label }) {
  return (
    <div className="cu-stat">
      <span className={`cu-stat-icon${tone ? ` cu-stat-${tone}` : ''}`}><NtIcon name={icon} size={18} /></span>
      <span className="cu-stat-value">{value}</span>
      <span className="cu-stat-label">{label}</span>
    </div>
  );
}

const pad2 = (n) => String(n).padStart(2, '0');
const toYmd = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

/** Periodi rapidi per il filtro per date: [chiave, dal, al] in formato AAAA-MM-GG. */
export function datePresets(nowInstant = new Date()) {
  // "Oggi" è il giorno nel fuso dell'utente (profilo o azienda), non quello del dispositivo.
  const [ty, tm, td] = zonedDayKey(nowInstant).split('-').map(Number);
  const now = new Date(ty, tm - 1, td);
  const y = now.getFullYear();
  const m = now.getMonth();
  const last30 = new Date(now);
  last30.setDate(last30.getDate() - 29);
  return [
    ['thisMonth', toYmd(new Date(y, m, 1)), toYmd(new Date(y, m + 1, 0))],
    ['last30', toYmd(last30), toYmd(now)],
    ['thisYear', `${y}-01-01`, `${y}-12-31`],
    ['lastYear', `${y - 1}-01-01`, `${y - 1}-12-31`],
  ];
}

/**
 * Filtro per periodo: pillola con "dal → al", pulsante per azzerare e periodi rapidi.
 * `labels`: { from, to, clear, presets: { thisMonth, last30, thisYear, lastYear } }.
 */
export function DateRangeFilter({ from, to, onChange, labels }) {
  const presets = datePresets();
  const active = presets.find(([, f, t]) => f === from && t === to);
  return (
    <div className="dr-group">
      <div className={'dr' + (from || to ? ' dr-set' : '')}>
        <input
          type="date"
          value={from}
          max={to || undefined}
          aria-label={labels.from}
          title={labels.from}
          onChange={(e) => onChange(e.target.value, to)}
        />
        <span className="dr-sep" aria-hidden="true">→</span>
        <input
          type="date"
          value={to}
          min={from || undefined}
          aria-label={labels.to}
          title={labels.to}
          onChange={(e) => onChange(from, e.target.value)}
        />
        {(from || to) && (
          <button type="button" className="dr-clear" aria-label={labels.clear} title={labels.clear} onClick={() => onChange('', '')}>
            ×
          </button>
        )}
      </div>
      <div className="dr-presets" role="group">
        {presets.map(([key, f, t]) => (
          <button
            key={key}
            type="button"
            className={'dr-chip' + (active && active[0] === key ? ' dr-chip-on' : '')}
            onClick={() => (active && active[0] === key ? onChange('', '') : onChange(f, t))}
          >
            {labels.presets[key]}
          </button>
        ))}
      </div>
    </div>
  );
}

/** Filtro per una singola data, con la stessa pillola e il pulsante per azzerare. */
export function DateFilter({ value, onChange, label, clearLabel }) {
  return (
    <div className={'dr' + (value ? ' dr-set' : '')}>
      <span className="dr-label">{label}</span>
      <input type="date" value={value} aria-label={label} onChange={(e) => onChange(e.target.value)} />
      {value && (
        <button type="button" className="dr-clear" aria-label={clearLabel} title={clearLabel} onClick={() => onChange('')}>
          ×
        </button>
      )}
    </div>
  );
}
